import OneDatePicker from '../OneDatePicker';
import {View, Platform, TouchableOpacity, Text} from 'react-native';
import getStyles from './styles';
import ModalWithButtons from '../ModalWithButtons';
import {useTheme} from '~contexts/ThemeContext';

interface IProps {
  isVisible: boolean;
  close: () => void;
  onPress: () => void;
  handleChooseMaxDate: (value?: Date) => void;
  date: Date;
  withoutMaxAvailableDate?: boolean;
  mixAvailableDate?: Date;
  maxAvailableDate?: Date;
  mode?: 'date' | 'time' | 'datetime';
}

const DateTimeModal = ({
  isVisible,
  close,
  onPress,
  handleChooseMaxDate: handleChooseDate,
  date,
  withoutMaxAvailableDate,
  mixAvailableDate,
  maxAvailableDate,
  mode,
}: IProps) => {
  const {colors} = useTheme();
  const styles = getStyles(colors);
  const isWeb = Platform.OS === 'web';

  // Web implementation: render as a simple overlay dialog
  if (isWeb && isVisible) {
    return (
      <View
        style={{
          position: 'absolute' as any,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex' as any,
          justifyContent: 'center' as any,
          alignItems: 'center' as any,
          zIndex: 1000,
        }}>
        <View
          style={{
            backgroundColor: colors.white,
            borderRadius: 12,
            padding: 20,
            width: '90%',
            maxWidth: 400,
            shadowColor: '#000',
            shadowOpacity: 0.3,
            shadowOffset: {width: 0, height: 2},
            shadowRadius: 8,
            elevation: 5,
          }}>
          <Text style={{fontSize: 18, fontWeight: 'bold', marginBottom: 16, color: colors.textPrimary}}>
            Select Date
          </Text>
          
          <View style={{marginBottom: 20}}>
            <OneDatePicker
              handleChooseDate={handleChooseDate}
              date={date}
              mixAvailableDate={mixAvailableDate}
              maxAvailableDate={maxAvailableDate}
              withoutMaxAvailableDate={withoutMaxAvailableDate}
              mode={mode}
            />
          </View>

          <View style={{flexDirection: 'row', justifyContent: 'flex-end', gap: 10}}>
            <TouchableOpacity
              onPress={close}
              style={{
                paddingVertical: 10,
                paddingHorizontal: 16,
                borderRadius: 6,
                backgroundColor: colors.border + '20',
              }}>
              <Text style={{color: colors.textPrimary, fontWeight: '600'}}>Cancel</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                onPress();
                close();
              }}
              style={{
                paddingVertical: 10,
                paddingHorizontal: 16,
                borderRadius: 6,
                backgroundColor: colors.primary,
              }}>
              <Text style={{color: colors.white, fontWeight: '600'}}>Done</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  }

  // Native implementation: use modal
  return (
    <ModalWithButtons onCloseModal={close} modalIsVisible={isVisible} onPress={onPress} backgroundColor={colors.white}>
      <View style={styles.container}>
        <OneDatePicker
          handleChooseDate={handleChooseDate}
          date={date}
          mixAvailableDate={mixAvailableDate}
          maxAvailableDate={maxAvailableDate}
          withoutMaxAvailableDate={withoutMaxAvailableDate}
          mode={mode}
        />
      </View>
    </ModalWithButtons>
  );
};

export default DateTimeModal;
